"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";

export function Commitment() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#02172A] text-white">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-x-12 md:gap-y-8 lg:gap-x-20">
          <div>
            <p className="mb-3 font-semibold md:mb-4">Mission</p>
            <h2 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[40px] lg:text-[40px] max-w-[500px]">
            Unsere Mission: Die digitale Welt sicherer machen           </h2>
          </div>
          <div>
            <p className="md:text-md leading-9">
            Gegründet von drei erfahrenen Digitalexperten, hat sich die Bollwerk-X GmbH zu einem führenden Anbieter für Cybersicherheitslösungen entwickelt. Unser Unternehmen unterstützt Organisationen nicht nur bei der Digitalisierung, sondern schützt sie gleichzeitig vor den immer komplexer werdenden Cyber-Bedrohungen. </p>
            {/* <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
              <Button title="Learn More" variant="secondary">
                Learn More
              </Button>
              <Button
                title="Join Us"
                variant="link"
                size="link"
                iconRight={<RxChevronRight />}
              >
                Join Us
              </Button>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
